import { CogPauseIcon } from './CogPauseIcon';

/**
 * author: Michael Irigoyen
 * id FE314FE9-CDD6-42DF-9F62-F470E3F0E2BF
 * name cog-pause
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cog-pause.svg
 * tags
 * - Settings 
 */
export const SettingsPauseIcon = CogPauseIcon;
export default SettingsPauseIcon